import { DIRECTIONS_URL } from "@/components/UtilBar";

const DirectionsSection = () => (
  <section id="directions" className="bg-neutral-950 py-14 md:py-20 lg:py-24">
    <div className="max-w-[1200px] mx-auto px-4 md:px-12 text-center">
      <h2 className="font-display text-2xl md:text-4xl font-semibold text-primary-foreground">
        Visit our Livonia showroom.
      </h2>
      <p className="mt-4 text-sm md:text-base text-primary-foreground/60 max-w-2xl mx-auto leading-relaxed">
        33475 West Seven Mile Road, Livonia, just west of Farmington Road, in the Biggby Coffee plaza across from the new Meijer.
      </p>
      <a
        href={DIRECTIONS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block mt-7 bg-primary text-primary-foreground px-8 py-3 rounded-full text-sm font-medium hover:bg-gold-400 transition-colors"
      >
        Get Directions
      </a>
    </div>
  </section>
);

export default DirectionsSection;
